import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import ParticularCandidates from "../particularcandidates/ParticularCandidates";
import { Table, Typography, Spin, Button } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const { Title } = Typography;

const formatDate = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatSalary = (amount) => {
  if (!amount) return "";
  return Math.round(amount).toLocaleString();
};

export default function SelectedCandidates({ mrf_id }) {
  const [candidates, setCandidates] = useState([]);
  const { authData, backUrl } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [showParticular, setShowParticular] = useState({
    show: false,
    cid: "",
  });

  const data = "Selected";

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${backUrl}/api/emp/candidates/?hr_final_status=${data}&requisition_id=${mrf_id}`,
        { headers: { Authorization: `Bearer ${authData?.access}` } }
      );
      setCandidates(res.data.results || res.data || []);
    } catch (err) {
      console.error("Error fetching candidates", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidates();
  }, []);

  const handleExportExcel = () => {
    const validCandidates = candidates.filter((c) => c.candidate_name !== "");
    if (validCandidates.length === 0) {
      toast.error("No selected candidate data available to export.");
      return;
    }

    const exportData = validCandidates.map((c) => ({
      "Candidate Name": c.candidate_name || "-",
      "Mobile Number": c.mobile_number || "-",
      "Email ID": c.email_id || "-",
      "Offered Salary": formatSalary(c.offered_salary) || "-",
      "Date of Joining": formatDate(c.date_of_joining) || "-",
      "Offer Sent Date": formatDate(c.offerletter_send_date) || "-",
      "Response Date": formatDate(c.candidate_response_date) || "-",
      "Response In Days": c.days_to_response_ol || "-",
      "Offer Status": c.offerletter_status || "Not Received",
      "Candidate Remarks": c.offer_letter_remarks || "No Remarks",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Selected Candidates");
    XLSX.writeFile(wb, `Selected_Candidates_MRF_${mrf_id || "List"}.xlsx`);
    toast.success("Selected candidates list exported successfully!");
  };

  const columns = [
    {
      title: "Candidate Name",
      dataIndex: "candidate_name",
      key: "candidate_name",
      render: (text, record) =>
        text ? (
          <a
            style={{ color: "#0e497b", cursor: "pointer" }}
            onClick={() =>
              setShowParticular({ ...showParticular, show: true, cid: record.id })
            }
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    { title: "Mobile No", dataIndex: "mobile_number", key: "mobile_number" },
    { title: "Mail", dataIndex: "email_id", key: "email_id" },
    {
      title: "Offered Salary",
      dataIndex: "offered_salary",
      key: "offered_salary",
      render: (salary) => formatSalary(salary),
    },
    {
      title: "Date Of Joining",
      dataIndex: "date_of_joining",
      key: "date_of_joining",
      render: (date) => formatDate(date),
    },
    {
      title: "Offer Sent Date",
      dataIndex: "offerletter_send_date",
      key: "offerletter_send_date",
      render: (date) => formatDate(date),
    },
    {
      title: "Response date",
      dataIndex: "candidate_response_date",
      key: "candidate_response_date",
      render: (date) => formatDate(date),
    },
    {
      title: "Response In days",
      dataIndex: "days_to_response_ol",
      key: "days_to_response_ol",
    },
    {
      title: "Offer Status",
      dataIndex: "offerletter_status",
      key: "offerletter_status",
      render: (status) => status || "Not Received",
    },
    {
      title: "Candidate Remarks",
      dataIndex: "offer_letter_remarks",
      key: "offer_letter_remarks",
      render: (remarks) => remarks || "No Remarks",
    },
  ];

  return (
    <>
      {!showParticular.show && (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
            <Button
              type="primary"
              icon={<FileExcelOutlined />}
              style={{ backgroundColor: "#217346", borderColor: "#217346" }}
              onClick={handleExportExcel}
            >
              Export Excel
            </Button>
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table
              rowKey="id"
              columns={columns}
              dataSource={candidates.filter((c) => c.candidate_name !== "")}
              pagination={{ pageSize: 10 }}
              bordered
              locale={{ emptyText: "No candidates found." }}
              components={{
                header: {
                  cell: (props) => (
                    <th {...props} style={{ backgroundColor: "#0e497b", color: 'white', marginTop: '20px' }}>
                      {props.children}
                    </th>
                  ),
                },
              }}
            />
          )}
        </>
      )}

      {showParticular.show && <ParticularCandidates cid={showParticular.cid} />}
    </>
  );
}
